import { render } from "./ForgotPasswordModal.vue?vue&type=template&id=2c7e5ee1&scoped=true"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js"

import "../../../assets/css/Modals/AuthenticationModals/ForgotPasswordModal.css?vue&type=style&index=0&id=2c7e5ee1&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7e5ee1"]])

export default __exports__